<template>
  <div class="mt-2">
    <Header></Header>
    <Tabla />
  </div>
</template>
<script>
import { defineAsyncComponent } from 'vue'
export default {
  name: 'verFallo',
  components: {
    Tabla: defineAsyncComponent(
      () => import('./componentsFallos/Tabla.vue')
    ),
    Header: defineAsyncComponent(
      () => import('./componentsFallos/Header.vue')
    )
  }
}
</script>
<style scoped>

</style>
